// Extracted from enInbox.ts (file-length cap): the "Add to Tracker" dialog and the footer button
// of Compose and Review to send (PREC-4497). Spread back into the `inbox` namespace in enInbox.ts.
export const enInboxTracker = {
	addToTracker: "Add to Custom Signal Tracker",
	addOrganizationOnly: "Add organization only (without person records)",
	trackerFooter: {
		add: "Add to Tracker",
		added: "Added to Tracker",
		addFailed: "Adding to the tracker failed.",
		pickTracker: "Pick a tracker first.",
		selectLead: "Select at least one lead.",
	},
};
